export default __webpack_public_path__ + "static/media/img-0527-norway-half-face.142d8155.png";